import { createReducer, on } from '@ngrx/store';
import * as GridsActions from '../actions/grids.actions';
import {Multiview} from '../../../services/api/multiviews/multiview-viewer.model';
import {UUID} from '../../../shared/types/uuid.type';

export const gridsFeatureKey = 'grids';

export interface State {
  record: Multiview[];
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: [],
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(GridsActions.loadGrids, (state: State): State => ({
    ...state,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(GridsActions.loadGridsSuccess, (_state: State, action): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(GridsActions.loadGridsFailure, (_state: State, action): State => ({
    record: [],
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(GridsActions.manyMultiviewsDeleted, (state: State, action): State => {
    const ids: UUID[] = action.ids;
    const record: Multiview[] = state.record.filter((multiview: Multiview) => {
      const id: UUID = multiview.id;
      return !ids.includes(id);
    });

    return {
      record: record,
      error: null,
      loaded: true,
      loading: false,
    };
  }),
  on(GridsActions.clearGridsState, (): State => ({
    record: [],
    error: null,
    loaded: false,
    loading: false,
  })),
);
